/**
 * Skeleton for Active and Match History sections (cards only).
 * Shown while initial friend stats data is loading.
 */

import React from 'react';
import { View } from 'react-native';
import { Skeleton } from '../../ui/Skeleton';
import { getFriendStatsStyles } from '../../../appStyles/_friendStats.styles';
import { useTheme } from '../../../src/theme/useTheme';
import { friendStatsLoadingSkeletonStyles as loadingStyles } from './FriendStatsLoadingSkeleton.styles';

export const FriendStatsLoadingSkeleton: React.FC<{ testID?: string }> = ({ testID }) => {
  const theme = useTheme();
  const styles = getFriendStatsStyles(theme);

  return (
    <View style={styles.container} testID={testID || 'friend-stats-loading-skeleton'}>
      <View style={loadingStyles.cardList}>
        <View style={loadingStyles.sectionHeader}>
          <Skeleton width={48} height={14} borderRadius={4} testID="skeleton-section-active" />
        </View>
        <View style={loadingStyles.card}>
          <View style={loadingStyles.cardBlock}>
            <Skeleton width="100%" height={88} borderRadius={12} />
          </View>
        </View>
        <View style={loadingStyles.card}>
          <View style={loadingStyles.cardBlock}>
            <Skeleton width="100%" height={88} borderRadius={12} />
          </View>
        </View>
        <View style={loadingStyles.sectionHeader}>
          <Skeleton width={100} height={14} borderRadius={4} testID="skeleton-section-history" />
        </View>
        <View style={loadingStyles.card}>
          <View style={loadingStyles.cardBlock}>
            <Skeleton width="100%" height={88} borderRadius={12} />
          </View>
        </View>
        <View style={loadingStyles.card}>
          <View style={loadingStyles.cardBlock}>
            <Skeleton width="100%" height={88} borderRadius={12} />
          </View>
        </View>
        <View style={loadingStyles.card}>
          <View style={loadingStyles.cardBlock}>
            <Skeleton width="100%" height={88} borderRadius={12} />
          </View>
        </View>
      </View>
    </View>
  );
};
